import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findClassify = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose?`+params,
        method: 'GET'
    })
}
